<template>
    <div class="bless">
        <div class="bless_content">
            <div class="content_logo">
                <img src="@/assets/form_logo.png" alt="">
            </div>
            <div class="content_box">
                <!--<div class="called">{{tabs[tabIndex]}}</div>-->
                <div class="content_des">
                    <div>亲爱的中国民航大学：</div>
                    <div class="indent">值此母校75周年华诞之际，祝您生日快乐！</div>
                    <div class="indent">
                        <span v-if="form.year"><span class="input_text">{{form.year}}</span>{{tabIndex==1?'年入职':'级'}}</span><span v-if="form.learnDept"><span class="input_text">{{form.learnDept}}</span><template v-if="!form.learnDept.endsWith('学院') && !form.learnDept.endsWith('系')">学院(系)</template></span><span v-if="form.major"><span class="input_text">{{form.major}}</span>专业</span><span>{{tabs[tabIndex]}}</span><span class="input_text">{{form.name}}</span>向您报到!
                    </div>
                    <div class="indent">明德至善，弘毅兴邦。母校永远是我们心灵的港湾。我以中航大人为荣，无论何时何地，母校的校训精神始终激励着我砥砺前行。</div>
                    <div class="indent"> 亲爱的母校，衷心祝愿您早日跻身国家“双一流”建设高校，全面建成中国特色、世界一流民航大学！</div>
                </div>
                <div class="commit" @click="commit">我来报道啦</div>
            </div>
        </div>
      <div class="form-alert">天涯虽远 云光寄思</div>
    </div>
</template>

<script>
import {personalInfo} from '../../utils/ajaxInterface'

export default {
  name: 'index',
  data () {
    return {
      form: {},
      tabIndex: 1,
      tabs: ['校友', '教职工', '在校学生']
    }
  },
  created () {
    this.getFormInfo()
  },
  methods: {
    commit () {
      this.$router.push('/map')
    },
    getFormInfo () {
      personalInfo().then(res => {
        this.form = res
        this.tabIndex = this.form.category - 1
      }).catch(e => {
        this.$toast.fail(e)
      })
    }
  }
}
</script>

<style scoped lang="less">
    .bless {
        background: url("../../assets/active_bg.png") center center no-repeat;
        background-size: cover;
        min-height: 100vh;
        padding: 40px 0 0;
        box-sizing: border-box;

        .bless_content {
            .content_logo {
                text-align: center;
                margin-bottom: 30px;

                img {
                    width: 234px;
                    height: 33px;
                }
            }

            .content_box {
                text-align: justify;
                width: 335px;
                height: 524px;
              margin: 0 auto;
                background: url("../../assets/active_small_bg.png") no-repeat center center;
                background-size: cover;
                padding: 39px 20px 0;
                box-sizing: border-box;
              position: relative;

                .called {
                  font-size: 24px;
                  color: #00428E;
                  width: 100px;
                  height: 36px;
                  line-height: 60px;
                  border-bottom: 4px solid transparent; /* 必须预留边框占位，transparent透明 */
                  border-image: linear-gradient( 90deg, #00A0E9 0%, rgba(0,103,221,0.02) 100%) 1;
                  margin-bottom: 6px;
                }

                .content_des {
                    box-sizing: border-box;
                    color: #00A0E9;
                    font-size: 14px;
                    line-height: 26px;
                    letter-spacing: 1px;

                    .indent {
                        text-indent: 1.4em;
                    }

                    span {
                        color: #00428E;
                        font-size: 14px;
                        font-weight: 700;
                    }
                }
                .commit{
                  position: absolute;
                    width: 246px;
                    height: 47px;
                    line-height: 47px;
                    text-align: center;
                    background: linear-gradient( 90deg, #1891FE 0%, #0EBDFF 100%);;
                    border-radius: 11px;
                    font-size: 16px;
                    color: #FFFFFF;
                  left: 50%;
                  transform: translate(-123px);
                  bottom: 40px;
                }
            }
        }
      .form-alert{
        margin-top: 30px;
        font-weight: bold;
        font-size: 26px;
        color: #004594;
        text-align: center;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/bless/index.vue